import React, { useEffect, useRef, useState } from "react";
import { Swiper } from "antd-mobile";
// import Community from './Community'
import NewCommunity from "../community/NewCommunity";
import Session from "./Session";
import Conversation from "./Conversation";
import useActiveState from "../../lib/useActiveState";
import Read from "./Read";
import { NavLink } from "../../lib/Navigation";
import "./css/Chat.css";
import general, { redux } from "../../general";
import UnreadBadge from "../community/UnreadBadge";
import URI from "urijs";
import Manager from "../components/Manager";

const tabItems = [
  { key: "vegetables", title: "论坛" },
  { key: "fruits", title: "群聊" },
];

export default function Chat(props) {
  const swiperRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const [user] = useActiveState("user");
  const [logined] = useActiveState("im-logined");
  const [messageUnreadNum, setMessageUnreadNum] = useState(0);
  const [init, setInit] = useState(false);

  const messUnreadCount = () => {
    general.axios.post("/getUnreadNumberMess").then((res) => {
      let { status, data } = res.data;
      if (!status.succeed) {
        return;
      }
      setMessageUnreadNum(data.community_unread_num);
    });
  };

  useEffect(() => {
    if (props.active) {
      messUnreadCount();
    }
  }, [props.active]);

  useEffect(() => {
    //活动跳转新的平台币
    window.addEventListener("message", function (event) {
      var result = event.data;      
      if (result?.type) {
        if (result.type == "nisptb") {
          //跳转平台币
          let url = URI("https://sys.99maiyou.com/home/MixPay/ptb")
            .addQuery("username", localStorage.getItem("username"))
            .addQuery("token", localStorage.getItem("token"))
            .addQuery("location_url", window.location.origin)
            .addQuery("agent", agent)
            .addQuery("from", "react")
            .toString();

          window.location.href =
            "#/iframe?url=" +
            encodeURIComponent(url) +
            "&title=充值&sinfo=nisptb";
        }
      }
    });
  }, []);

  return (
    <div className="screen-chat-index">
      <div
        style={{
          position: "fixed",
          top: 0,
          maxWidth: 720,
          margin: "0 auto",
          left: 0,
          right: 0,
          zIndex: 2,
        }}
      >
        {init && (
          <div className="chat-navs">
            {tabItems.map((item, index) => (
              <div
                onClick={() => {
                  setActiveIndex(index);
                  swiperRef.current?.swipeTo(index);
                  Manager.push({event_id: index == 0 ? 'A-7' : 'A-5-11'});
                }}
                className={
                  "chat-navs-item " +
                  `item${activeIndex} ` +
                  (activeIndex == index ? "active" : "")
                }
                key={item.key}
              >
                {item.title}
              </div>
            ))}
            {user.isLogin && logined && (
              <div className="unread-badge">
                <UnreadBadge active={props.active}></UnreadBadge>
              </div>
            )}
          </div>
        )}

        <div>
          {activeIndex == 0 && (
            <NavLink
              onClick={()=>{
                Manager.push({event_id: 'A-7-1'})
              }}
              to="/message/list?type=community"
              className={"message " + (messageUnreadNum > 0 ? "unread" : "")}
            >
              消息
            </NavLink>
          )}
          {activeIndex == 1 &&
            localStorage.getItem("yx_token") &&
            user.isLogin &&
            logined && <Read active={props.active}></Read>}
        </div>
      </div>

      <div>
        <div
          className="chat-container"
          style={{ display: activeIndex == 0 ? "block" : "none" }}
        >
          <NewCommunity
            prefix={"main-"}
            isMainCommunity={true}
            active={props.active && activeIndex == 0}
            handleInit={() => setInit(true)}
          ></NewCommunity>
        </div>
        <div
          className="chat-container"
          style={{ display: activeIndex == 1 ? "block" : "none" }}
        >
          {user.isLogin ? (
            <Conversation></Conversation>
          ) : (
            <Session icon="hot"></Session>
          )}
        </div>
      </div>
    </div>
  );
}
